import categoryList_es from "../../components/CategoryList/translation/categoryList_es.json";
import categoryList_en from "../../components/CategoryList/translation/categoryList_en.json";
import demo_steps_es from "../../components/DemoSteps/translation/demo_steps_es.json";
import demo_steps_en from "../../components/DemoSteps/translation/demo_steps_en.json";
import footer_es from "../../components/Footer/translation/footer_es.json";
import footer_en from "../../components/Footer/translation/footer_en.json";
import header_es from "../../components/Header/translation/header_es.json";
import header_en from "../../components/Header/translation/header_en.json";
import masthead_es from "../../components/Masthead/translation/masthead_es.json";
import masthead_en from "../../components/Masthead/translation/masthead_en.json";
import masthead_demo_es from "../../components/MastheadDemo/translation/masthead_demo_es.json";
import masthead_demo_en from "../../components/MastheadDemo/translation/masthead_demo_en.json";
import mobile_app_es from "../../components/MobileApp/translation/mobile_app_es.json";
import mobile_app_en from "../../components/MobileApp/translation/mobile_app_en.json";
import modal_es from "../../components/Modal/translation/modal_es.json";
import modal_en from "../../components/Modal/translation/modal_en.json";
import tabControl_es from "../../components/TabControl/translation/tabControl_es.json";
import tabControl_en from "../../components/TabControl/translation/tabControl_en.json";
import navigation_modal_en from "../../components/NavigationModal/translation/navigation_modal_en.json";
import navigation_modal_es from "../../components/NavigationModal/translation/navigation_modal_es.json";
import content_block_es from "../../components/ContentBlock/translation/content_block_es.json";
import content_block_en from "../../components/ContentBlock/translation/content_block_en.json";
import error_block_en from "../../components/ErrorBlock/translation/error_block_en.json";
import error_block_es from "../../components/ErrorBlock/translation/error_block_es.json";

/**
 * lang_resources is the object in charge of wrapping all the required namespaces for the application.
 * Every component should have its own namespace defined here. Also the imports above will indicate the location of the translation keys.
 */
export const langResources = {
    en: {
        categoryList: categoryList_en,
        demo_steps: demo_steps_en,
        footer: footer_en,
        header: header_en,
        masthead: masthead_en,
        masthead_demo: masthead_demo_en,
        mobile_app: mobile_app_en,
        modal: modal_en,
        tabControl: tabControl_en,
        navigation_modal: navigation_modal_en,
        content_block: content_block_en,
        error_block: error_block_en
    },
    es: {
        categoryList: categoryList_es,
        demo_steps: demo_steps_es,
        footer: footer_es,
        header: header_es,
        masthead: masthead_es,
        masthead_demo: masthead_demo_es,
        mobile_app: mobile_app_es,
        modal: modal_es,
        tabControl: tabControl_es,
        navigation_modal: navigation_modal_es,
        content_block: content_block_es,
        error_block: error_block_es
    }
};